import React from "react";
import classes from "./styles.module.scss";
import classNames from "classnames";
import WarningIcon from "assets/images/icons/warning.svg";
import ErrorIcon from "assets/images/icons/warning-red.svg";
import ResetIcon from "assets/images/icons/Icon-Reset-blue.svg";
import NoResultsIcon from "assets/images/icons/warning-yellow.svg";

const typeClasses = (type) =>
    ({
        info: classes.info,
        warning: classes.warning,
        error: classes.error,
        changes: classes.info,
        noResults: classes.warning,
        default: "",
    })[type || "default"];

const typeIcons = (type) =>
    ({
        warning: WarningIcon,
        error: ErrorIcon,
        changes: ResetIcon,
        noResults: NoResultsIcon,
        default: "",
    })[type || "default"];

const FixedBanner = ({ className, type, children }) => {
    const Icon = typeIcons(type);

    return (
        <div
            className={classNames(classes.fixedBanner, {
                [typeClasses(type)]: type,
                [className]: className,
            })}
        >
            {Icon && <img src={Icon} alt={`${type}_icon`} />}
            {children}
        </div>
    );
};

export default FixedBanner;
